module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.contentItem.contentType === 'figure') ? [_c('content-figure', {
    attrs: {
      "figure-attr": _vm.contentItem.content
    }
  })] : (_vm.contentItem.contentType === 'table') ? [_c('content-table', {
    attrs: {
      "table-content": _vm.contentItem
    }
  })] : [_c('content-element', {
    attrs: {
      "tag-name": _vm.contentItem.contentType || 'p'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentItem.content || _vm.contentItem.content_part)
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da5a9792"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/article-items/ContentItemComponent.vue
// module id = 1478
// module chunks = 1